import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getDashboardOrgInfo } from '@api/dashboard';
import { IDashboardOrgInfoData } from '@interfaces/dashboard';

export const handleGetDashboardOrgInfo = createAsyncThunk<
  AxiosResponse<IDashboardOrgInfoData>,
  void
>('getDashboardOrgInfo', getDashboardOrgInfo);
